import { html, LitElement, TemplateResult } from "lit";
import { customElement, property } from "lit/decorators.js";
import { IAlumno } from "../../../../data/models/Entities";
import { _GRUPOSINFO_MAP } from "../../../../data/services/Grupo";
import _L from "../../../../utils/Labels";
import { MEntregaItem } from "../../models/MEntregaItem";
import "./EntregaItem.scss";

@customElement('app-proximidad-entrega-item')
export class EntregaItem extends LitElement {
    @property({ type: Object, attribute: false }) public data: MEntregaItem | null;

    protected createRenderRoot(): HTMLElement | DocumentFragment {
        return this;
    }

    protected render(): TemplateResult {
        if (!this.data.hasData()) {
            return html``;
        }
        return html`
        <div class="proximidad-entrega-item-content">
            <div class="left">
                ${this.renderAlumnos()}
                ${this.renderTutores()}
            </div>
            <div class="right">
                ${this.renderStatus()}
                <app-relative-time class="time" .k_date="${this.data.getFechaPosicionMasReciente()}"> </app-relative-time>
            </div>
        </div>
        `;
    }

    private renderStatus(): TemplateResult {
        const tutorMasProximo = this.data.getTutorMasProximo();
        if (!tutorMasProximo) {
            return html``;
        }
        // this.setAttribute("style", `--color-proximidad: ${tutorMasProximo.getColorForEstado()};`);

        return html`
            <div class="status">
                <span class="distance">${_L("ui.proximidad.a_distancia", tutorMasProximo.getDistanciaString())}</span>
            </div>
        `;
    }

    private renderAlumnos(): TemplateResult {
        const alumnos: IAlumno[] = this.data.getAlumnosCompartidosEnClase();
        return html`
            ${alumnos.map(alumno => html`
                <div class="alumno">
                    <app-avatar-alumno .k_alumno="${alumno}" k_width="22px" k_height="22px"></app-avatar-alumno>
                    <span>
                        ${alumno._NombreCompleto}
                        ${this.data.showGrupo && alumno.GrupoActivo && _GRUPOSINFO_MAP.has(alumno.GrupoActivo)
                ? html`<span class="grupo">(${_GRUPOSINFO_MAP.get(alumno.GrupoActivo).NombreGrupo})</span>`
                : html``}
                    </span>
                </div>
            `)}
        `;
    }

    private renderTutores(): TemplateResult {
        return html`
            <div class="tutores">
                Viene: ${this.data.getNombresTutores()}
            </div>
        `;
    }
}